export const getAdminData = (state) => state.topics.data;
export const getIsLoading = (state) => state.topics.isLoading;
export const getIsLoadingMessages = (state) => state.topics.isLoadingMessages;
export const getIsDetailsPanelOpen = (state) => state.topics.isDetailsPanelOpen;
export const getSelectedTopic = (state) => state.topics.selectedTopic;
export const getMessages = (state) => state.topics.messages;
export const getError = (state) => state.topics.error;
export const getCustomers = (state) => state.common.customers;
